module.exports = __webpack_public_path__ + "img/user-avater2.939d8d77.png";